<template>
	<svg
		xmlns:dc="http://purl.org/dc/elements/1.1/"
		xmlns:cc="http://creativecommons.org/ns#"
		xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
		xmlns:svg="http://www.w3.org/2000/svg"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
		xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
		:width="width"
		:height="height"
		viewBox="0 0 26.458332 26.458333"
		id="svg2"
		version="1.1"
		inkscape:version="0.91 r13725"
		sodipodi:docname="color.svg"
		inkscape:export-filename="/Users/tiagosilva/Google Drive/Projects/Vector/naltio/color.png"
		inkscape:export-xdpi="90"
		inkscape:export-ydpi="90"
	>
		<defs id="defs4" />
		<sodipodi:namedview
			id="base"
			pagecolor="#ffffff"
			borderColor="#666666"
			borderopacity="1.0"
			inkscape:pageopacity="0.0"
			inkscape:pageshadow="2"
			inkscape:zoom="5.49"
			inkscape:cx="50"
			inkscape:cy="50"
			inkscape:document-units="px"
			inkscape:current-layer="g3391"
			showgrid="false"
			units="px"
			inkscape:snap-smooth-nodes="true"
			inkscape:window-width="1280"
			inkscape:window-height="751"
			inkscape:window-x="0"
			inkscape:window-y="1"
			inkscape:window-maximized="1"
			inkscape:snap-page="true"
			borderlayer="true"
			showguides="true"
			showborder="true"
		>
			<inkscape:grid type="xygrid" id="grid4413" />
		</sodipodi:namedview>
		<metadata id="metadata7">
			<rdf:RDF>
				<cc:Work rdf:about>
					<dc:format>image/svg+xml</dc:format>
					<dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
					<dc:title />
				</cc:Work>
			</rdf:RDF>
		</metadata>
		<g
			inkscape:label="Layer 1"
			inkscape:groupmode="layer"
			id="layer1"
			transform="translate(0,-270.54166)"
		>
			<text
				xml:space="preserve"
				style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:125%;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
				x="22.407654"
				y="289.17575"
				id="text4154"
				sodipodi:linespacing="125%"
			>
				<tspan
					sodipodi:role="line"
					id="tspan4156"
					x="22.407654"
					y="289.17575"
					style="stroke-width:0.26458332px"
				/>
			</text>
			<g
				id="g4543"
				inkscape:export-xdpi="517.39001"
				inkscape:export-ydpi="517.39001"
				transform="translate(4.793522,43.421307)"
			>
				<g id="g4669" transform="matrix(1.0826531,0,0,1.0826531,33.439266,-72.829734)">
					<g id="g4715" transform="translate(2.4438422,-1.9550717)">
						<g id="g4158">
							<g
								transform="translate(-38.106319,4.2936488)"
								id="g3391"
								inkscape:export-xdpi="84.480049"
								inkscape:export-ydpi="84.480049"
								inkscape:export-filename="/Users/tiagosilva/Repositories/naltio/application/static/images/logotext.png"
							>
								<g id="g4193">
									<path
										id="path3395"
										transform="matrix(0.24438421,0,0,0.24438421,0.34849857,274.71239)"
										d="M 20.226562 10 C 3.9867667 10 3.9867667 64.132813 20.226562 64.132812 L 36.466797 64.132812 C 28.562685 64.132812 26.435287 35.2972 30.072266 19.720703 C 39.822058 35.297054 51.67688 64.132812 63.533203 64.132812 L 79.773438 64.132812 C 96.013233 64.132812 96.013233 10 79.773438 10 L 63.533203 10 C 71.340131 10 73.516558 38.142605 70.064453 53.84375 C 60.469767 38.155262 48.193226 10 36.466797 10 L 20.226562 10 z M 84.183594 70.953125 C 81.903389 70.953125 80.051022 71.69952 78.626953 73.191406 C 77.211363 74.674808 76.503906 76.54728 76.503906 78.810547 L 76.503906 82.142578 C 76.503906 84.414329 77.216556 86.291989 78.640625 87.775391 C 80.064691 89.258792 81.917058 90 84.197266 90 C 86.494424 90 88.358471 89.258792 89.791016 87.775391 C 91.232036 86.291989 91.953125 84.414329 91.953125 82.142578 L 91.953125 78.810547 C 91.953125 76.54728 91.232036 74.674808 89.791016 73.191406 C 88.349992 71.69952 86.480752 70.953125 84.183594 70.953125 z M 8.046875 71.21875 L 8.046875 89.732422 L 11.759766 89.732422 L 11.759766 77.09375 L 11.835938 77.082031 L 19.3125 89.732422 L 23.011719 89.732422 L 23.011719 71.220703 L 19.3125 71.220703 L 19.3125 83.845703 L 19.236328 83.857422 L 11.759766 71.21875 L 8.046875 71.21875 z M 31.251953 71.220703 L 24.880859 89.732422 L 28.632812 89.732422 L 29.890625 85.740234 L 36.388672 85.740234 L 37.648438 89.732422 L 41.398438 89.732422 L 35.052734 71.220703 L 31.251953 71.220703 z M 43.140625 71.220703 L 43.140625 89.732422 L 55.091797 89.732422 L 55.091797 86.884766 L 46.853516 86.884766 L 46.853516 71.220703 L 43.140625 71.220703 z M 53.160156 71.220703 L 53.160156 74.080078 L 58.373047 74.080078 L 58.373047 89.732422 L 62.085938 89.732422 L 62.085938 74.080078 L 67.324219 74.080078 L 67.324219 71.220703 L 53.160156 71.220703 z M 69.664062 71.220703 L 69.664062 89.732422 L 73.376953 89.732422 L 73.376953 71.220703 L 69.664062 71.220703 z M 84.183594 73.851562 C 85.446608 73.851562 86.439646 74.314326 87.160156 75.238281 C 87.880669 76.162236 88.240234 77.344147 88.240234 78.785156 L 88.240234 82.142578 C 88.240234 83.609039 87.88391 84.804561 87.171875 85.728516 C 86.45984 86.652471 85.468755 87.113281 84.197266 87.113281 C 82.942727 87.113281 81.963322 86.652471 81.259766 85.728516 C 80.556207 84.804561 80.205078 83.609039 80.205078 82.142578 L 80.205078 78.785156 C 80.205078 77.335663 80.551013 76.153752 81.246094 75.238281 C 81.941177 74.314326 82.920583 73.851562 84.183594 73.851562 z M 33.107422 75.556641 L 33.183594 75.556641 L 35.472656 82.828125 L 30.806641 82.828125 L 33.107422 75.556641 z "
										style="fill:brown;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:0.26458332;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
									/>
									<path
										inkscape:connector-curvature="0"
										id="path4162"
										d="m 9.260408,277.15623 c -0.7141931,0 -1.2340956,0.96814 -1.5627224,2.37559 2.3826964,3.80661 5.2798264,10.85362 8.1773254,10.85362 0.737943,0 1.269827,-1.03035 1.596134,-2.51449 -2.34479,-3.83402 -5.344983,-10.71472 -8.210737,-10.71472 z"
										style="fill:#ffffff;fill-opacity:0.69803922;fill-rule:evenodd;stroke:none;stroke-width:0;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:0.69803922"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: "Logo",
	props: ["width", "height", "color"]
};
</script>

<style scoped>
#path3395 {
	fill: var(--v-primary-base) !important;
}
</style>